// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"641":"2262a9dcb17c14cd","3209":"35fd44cb86d46059","5387":"fc361e7dc80c088f"}[chunkId] + ".css";
};